module.exports = __webpack_public_path__ + "static/media/Breadcumbs_arrow.39a485d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Breadcumbs_arrow.svg
// module id = 624
// module chunks = 0